const ABSOLUTE_URL_PATTERN = /^(?:https?:\/\/|\/\/)\S+$/i;

export function parseLiteralImageUrl(resolved: string): string | undefined {
  const trimmed = resolved.trim();
  return ABSOLUTE_URL_PATTERN.test(trimmed) ? trimmed : undefined;
}
